import { Cell } from '@pelckmans/elementis/components/table/cell';
import { ComponentProps } from 'react';
import { Score } from '../../../api/results';
import { ScorableItem } from '../../../api/scorable-items';
import { formatAbsoluteScore } from '@pelckmans/elementis/components/results';

export default function AbsoluteScoreCell({
  scorableItem,
  score,
  needsGrading,
  highlighted,
}: {
  scorableItem: ScorableItem;
  score?: Score['score'];
  needsGrading?: boolean;
} & Pick<ComponentProps<typeof Cell>, 'highlighted'>) {
  const showAbsoluteScore = scorableItem.showPoints && score?.maximum && !needsGrading;
  return (
    <Cell minWidth="sm" maxWidth="sm" highlighted={highlighted}>
      {showAbsoluteScore ? <Cell.Text title={formatAbsoluteScore(score)} /> : null}
    </Cell>
  );
}
